import Vue from 'vue';
import progressBar from '@gitlab-org/gitlab-ui/dist/base/progress_bar';

Vue.component('gl-progress-bar', progressBar);
